import React, { memo } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { makeSelectFilterMenuStatus, makeSelectSpecialFilterDataArray, makeSelectSpecialFilterId } from '../selectors';
import { toggleSpecialFilterMenu } from './actions';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PillYellow, { PillText } from '../../../utils/Components/PillYellow';
import { setSpecialFilterDataArray, setSpecialFilterId } from '../actions';

const key = 'special';

export const FilterPills = ({ specialFilterId, specialFilterDataArray, onSetSpecialFilterId, onSetSpecialFilterDataArray }) => {
  if (specialFilterDataArray.length === 0) {
    return <></>;
  }

  const handlePillClick = (index) => {
    onSetSpecialFilterId([...specialFilterId.slice(0, index), ...specialFilterId.slice(index + 1)]);
    onSetSpecialFilterDataArray([...specialFilterDataArray.slice(0, index), ...specialFilterDataArray.slice(index + 1)]);
  };

  /**
   * Main return function.
   */
  return specialFilterDataArray.map((item, index) => (
    <PillYellow key={`${key}_${item}`} onClick={() => handlePillClick(index)}>
      <PillText>{item}</PillText>
      <FontAwesomeIcon icon={faTimes} />
    </PillYellow>
  ));
};

FilterPills.propTypes = {
  specialFilterId: PropTypes.array,
  onToggleSpecialFilterMenu: PropTypes.func,
  specialFilterMenuStatus: PropTypes.bool,
};

FilterPills.defaultProps = {
  specialFilterDataArray: [],
  onToggleSpecialFilterMenu: () => {},
  specialFilterMenuStatus: true,
};

const mapStateToProps = createStructuredSelector({
  specialFilterId: makeSelectSpecialFilterId(),
  specialFilterMenuStatus: makeSelectFilterMenuStatus(),
  specialFilterDataArray: makeSelectSpecialFilterDataArray(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onToggleSpecialFilterMenu: (value) => dispatch(toggleSpecialFilterMenu(value)),
    onSetSpecialFilterId: (value) => dispatch(setSpecialFilterId(value)),
    onSetSpecialFilterDataArray: (value) => dispatch(setSpecialFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(FilterPills);
